const {
  SOURCE_MOOT,
} = require('./../../../../sourceList')
const {
  CR_1_2,
} = require('./../../../../crList')
const {
  SIZE_TINY,
} = require('./../../../../sizeList')
const {
  CREATURE_TYPE_ANVILWROUGHT,
  CREATURE_TYPE_CONSTRUCT,
} = require('./../../../../creatureTypeIdList')
const {
  SKILL_PERCEPTION,
} = require('./../../../../skillList')
const {
  ALIGNMENT_NO,
} = require('./../../../../aligmentList')
const {
  SPEED_FLY,
  SPEED_WALK,
} = require('./../../../../speedList')
const {
  ATTACK_MELEE_WEAPON,
} = require('./../../../../attackTypeList')
const {
  DAMAGE_FIRE,
  DAMAGE_PIERCING,
  DAMAGE_POISON,
} = require('./../../../../damageTypeList')
const {
  GENDER_FEMALE,
} = require('./../../../../genderList')
const {
  LANG_ONE_OF_ITS_CREATOR,
} = require('./../../../../languageIdList')
const {
  SENSE_DARK_VISION,
} = require('./../../../../senseList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  ABILITY_KEEN_SIGHT,
} = require('./../../../../creatureAbilityList')
const {
  ARMOR_TYPE_NATURAL,
} = require('./../../../../armorTypeList')
const {
  CONDITION_CHARMED,
  CONDITION_EXHAUSTION,
  CONDITION_PARALYZED,
  CONDITION_PETRIFIED,
  CONDITION_POISONED,
} = require('./../../../../conditionList')
const {
  PROF_NORMAL,
} = require('./../../../../proficiencyList')
const {
  anvilwroughtDescription,
} = require('./../../../../textCommonParts')
const {
  CREATURE_ANVILWROUGHT_RAPTOR,
} = require('./../../../../creatureIdList')

module.exports = {
  name: 'Кованая птица',
  nameEn: 'Anvilwrought Raptor',
  id: CREATURE_ANVILWROUGHT_RAPTOR,
  couldBeFamiliar: true,
  description: [
    {
      header: 'Кованая птица',
      text: `Ценимые среди тавматургов Мелетиды, кованые птицы часто изготавливаются в виде соколов или сов. Большинство из них служит посыльными или шпионами. Они летают над шумными улицами или высоко в небесах, перенося или выискивая необходимую их хозяевам информацию.`,
      source: {
        id: SOURCE_MOOT,
        page: 210,
      },
    },
    {
      header: 'Вариант: Кованая птица как фамильяр',
      text: `Некоторые [кованые птицы](CREATURE:${CREATURE_ANVILWROUGHT_RAPTOR}) создаются специально чтобы быть фамильярами. Такие существа обладают следующей особенностью:

# Фамильяр

Кованая птица может служить другому существу фамильяром, создав магическую телепатическую связь с желающим того хозяином. Пока они связаны, хозяин может ощущать то же, что и кованая птица, пока они находятся в пределах мили друг от друга.`,
      source: {
        id: SOURCE_MOOT,
        page: 210,
      },
    },
    anvilwroughtDescription,
  ],
  note: {
    text: `Я знаю, как она легка, ведь я видела её в полёте. Я знаю, как она тяжела, ведь я видела её в бою`,
    author: `Бригона, солдат из Мелетиды`,
  },
  sizeType: SIZE_TINY,
  creatureTypeIdList: [
    CREATURE_TYPE_ANVILWROUGHT,
    CREATURE_TYPE_CONSTRUCT,
  ],
  alignmentId: ALIGNMENT_NO,
  source: {
    id: SOURCE_MOOT,
    page: 210,
  },
  armor: {
    ac: 14,
    type: ARMOR_TYPE_NATURAL,
  },
  hp: {
    diceCount: 4,
  },
  speed: {
    [SPEED_WALK]: 10,
    [SPEED_FLY]: 60,
  },
  params: {
    [PARAM_STR]: 12,
    [PARAM_DEX]: 16,
    [PARAM_CON]: 14,
    [PARAM_INT]: 3,
    [PARAM_WIT]: 14,
    [PARAM_CHA]: 1,
  },
  skillCollection: {
    [SKILL_PERCEPTION]: PROF_NORMAL,
  },
  immunityList: [
    DAMAGE_FIRE,
    DAMAGE_POISON,
  ],
  immunityConditionList: [
    CONDITION_CHARMED,
    CONDITION_EXHAUSTION,
    CONDITION_PARALYZED,
    CONDITION_PETRIFIED,
    CONDITION_POISONED,
  ],
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 120,
    },
  ],
  languageList: [
    {
      id: LANG_ONE_OF_ITS_CREATOR,
      doNotSpeak: true,
    },
  ],
  cr: CR_1_2,
  featureList: [
    ABILITY_KEEN_SIGHT,
    {
      name: 'Запись-имитация',
      nameEn: 'Recorded Mimicry',
      description: `★СУЩЕСТВО★ может воспроизвести любой звук, услышанный ★им★ за последние 24 часа, включая голоса. Существо, слышащее воспроизводимый звук, может определить что это имитация при успешной проверке Мудрости (Проницательность) СЛ 12.`,
    },
  ],
  actionList: [
    {
      name: 'Мультиатака',
      description: `★СУЩЕСТВО★ совершает две атаки _Клювом_`,
    },
    {
      name: 'Клюв',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 5,
        range: 5,
        hit: {
          type: DAMAGE_PIERCING,
          diceCount: 1,
          diceType: 4,
          diceBonus: 3,
        },
      },
    },
  ],
  genderId: GENDER_FEMALE,
}
